// Journal: gemeinsame Konstanten, API und Helfer (aus der bisherigen JournalPage uebernommen,
// Emojis aus den Anzeigetexten entfernt; DB-Werte unveraendert).
import { apiClient } from "../api/client";

export const ASSET_CLASSES = [
  { value: "stock",           label: "Aktie" },
  { value: "etf",             label: "ETF" },
  { value: "options_warrant", label: "Optionsschein" },
  { value: "knock_out",       label: "Knock-Out" },
  { value: "crypto",          label: "Krypto" },
];
export const CATEGORIES = [
  { value: "swing_trade",   label: "Swing Trade" },
  { value: "intraday",      label: "Intraday" },
  { value: "leap",          label: "LEAP" },
  { value: "longterm",      label: "Langzeitinvest" },
  { value: "etf_sparplan",  label: "ETF Sparplan" },
  { value: "earnings_play", label: "Earnings Play" },
  { value: "hochrisiko",    label: "Hochrisiko" },
  { value: "dividende",     label: "Dividende" },
  { value: "sonstiges",     label: "Sonstiges" },
];
// v5.1: Werte entsprechen EXAKT der strategy-Spalte aus signal_outcomes,
// damit Journal-Eintraege gegen Scanner-Signale auswertbar sind.
// value = DB-Wert (maschinenlesbar), label = Anzeige.
export const SIGMUND_STRATEGIES: { group: string; items: { value: string; label: string }[] }[] = [
  { group: "Swing", items: [
    { value: "ADX_Continuation",  label: "ADX Continuation" },
    { value: "Pre-Earnings Vega", label: "Pre-Earnings Vega" },
    { value: "Pullback_Trend",    label: "Pullback Trend" },
    { value: "Breakout_Range",    label: "Breakout Range" },
    { value: "Week52_Approach",   label: "Week52 Approach" },
    { value: "Hammer_Engulfing",  label: "Hammer / Engulfing" },
    { value: "RSI_Divergence",    label: "RSI Divergence" },
    { value: "Volume_Breakout",   label: "Volume Breakout" },
    { value: "BB_Squeeze",        label: "BB Squeeze" },
  ]},
  { group: "Longterm", items: [
    { value: "MA200",        label: "MA200" },
    { value: "Momentum_90",  label: "Momentum 90" },
    { value: "Golden_Cross", label: "Golden Cross" },
    { value: "Week52_High",  label: "Week52 High" },
  ]},
  { group: "Intraday", items: [
    { value: "pullback_ema",  label: "Pullback to EMA" },
    { value: "vwap_bounce",   label: "VWAP Bounce" },
    { value: "range_trading", label: "Range Trading" },
    { value: "gap_and_go",    label: "Gap & Go" },
    { value: "orb",           label: "Opening Range Breakout" },
  ]},
];
export const CURRENCIES = ["EUR","USD","GBP","CHF","CAD","AUD"];
export const BROKERS = ["Consorsbank","Comdirect","Smartbroker","Smartbroker+","Trade Republic","Scalable Capital","Finanzen.net Zero","Robinhood","Bison","Sonstiger"];

export const EMPTY_FORM: any = {
  symbol:"",isin:"",name:"",broker:"",asset_class:"stock",call_put:"",direction:"",
  category:"swing_trade",underlying_symbol:"",underlying_price_at_entry:"",
  is_sparplan:false,signal_source:false,sigmund_strategies:[""],
  sigmund_score:"",sigmund_win_prob:"",entry_price:"",exit_price:"",
  quantity:"1",currency:"EUR",fees_entry:"",fees_exit:"",tax:"",current_price:"",
  opened_at:"",closed_at:"",notes:"",
};
export const nowLocal = () => {
  const d = new Date(); d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 16);
};
export const EMPTY_TRANCHE = { typ:"kauf", datum:"", kurs:"", stueckzahl:"", notiz:"", kosten:"", steuer:"" };

export const api = {
  getTrades:()=>apiClient.get(`/journal/?status=ALL`).then(r=>Array.isArray(r.data)?r.data:[]),
  addTrade:(d:any)=>apiClient.post("/journal/",d).then(r=>r.data),
  updateTrade:(id:number,d:any)=>apiClient.patch(`/journal/${id}`,d).then(r=>r.data),
  deleteTrade:(id:number)=>apiClient.delete(`/journal/${id}`).then(r=>r.data),
  searchSymbol:(q:string)=>apiClient.get(`/journal/search-symbol?q=${encodeURIComponent(q)}`).then(r=>r.data),
  uploadAtt:(tid:number,file:File,type:string)=>{const fd=new FormData();fd.append("file",file);fd.append("attachment_type",type);return apiClient.post(`/journal/${tid}/attachments`,fd,{headers:{"Content-Type":"multipart/form-data"}}).then(r=>r.data);},
  deleteAtt:(tid:number,aid:number)=>apiClient.delete(`/journal/${tid}/attachments/${aid}`).then(r=>r.data),
  getTranchen:(tid:number)=>apiClient.get(`/journal/${tid}/tranchen`).then(r=>r.data),
  addTranche:(tid:number,d:any)=>apiClient.post(`/journal/${tid}/tranchen`,d).then(r=>r.data),
  deleteTranche:(tid:number,trid:number)=>apiClient.delete(`/journal/${tid}/tranchen/${trid}`).then(r=>r.data),
  updateTranche:(tid:number,trid:number,d:any)=>apiClient.patch(`/journal/${tid}/tranchen/${trid}`,d).then(r=>r.data),
  priceAt:(symbol:string,dt:string)=>apiClient.get(`/journal/price-at-time?symbol=${encodeURIComponent(symbol)}&datetime_str=${encodeURIComponent(dt)}`).then(r=>r.data?.price ?? null).catch(()=>null),
};

// Datetime-local: naive lokale Zeit, kein UTC-Overhead
export const toLocalInput = (dtStr: string | null | undefined): string => dtStr ? String(dtStr).slice(0, 16) : "";
export const clampDate=(v:string)=>{if(!v)return v;const[d,t]=v.split("T");if(!d)return v;const p=d.split("-");if(p[0]&&p[0].length>4)p[0]=p[0].slice(0,4);return p.join("-")+(t?"T"+t:"");};

export function buildPayload(src:any){
  const strategies=(src.sigmund_strategies||[""]).filter((s:string)=>s&&s.trim()!=="");
  const n=(x:any)=>x===""||x===null||x===undefined||isNaN(parseFloat(x))?null:parseFloat(x);
  return{...src,
    entry_price:src.is_sparplan?0:(n(src.entry_price)??0),
    quantity:src.is_sparplan?0:(n(src.quantity)??1),
    exit_price:n(src.exit_price),
    sl_price:n(src.sl_price),tp_price:n(src.tp_price),   // bleiben erhalten (z. B. aus der Ablage)
    fees_entry:n(src.fees_entry)??0,
    fees_exit:n(src.fees_exit)??0,
    tax:n(src.tax)??0,
    current_price:n(src.current_price),
    sigmund_score:n(src.sigmund_score),
    sigmund_win_prob:n(src.sigmund_win_prob),
    signal_strategy:strategies.join(", ")||null,
    underlying_price_at_entry:n(src.underlying_price_at_entry),
    underlying_symbol:src.underlying_symbol||null,
    sigmund_strategies:undefined, attachments:undefined,
    opened_at:toLocalInput(src.opened_at)||nowLocal(),
    closed_at:src.closed_at?toLocalInput(src.closed_at):null,
    call_put:src.call_put||null,direction:src.direction||null,
    isin:src.isin||null,broker:src.broker||null,
  };
}
// Trade aus der API -> Formularzustand
export const tradeToForm=(t:any)=>({...t,opened_at:toLocalInput(t.opened_at),closed_at:toLocalInput(t.closed_at),
  sigmund_strategies:t.signal_strategy?String(t.signal_strategy).split(", "):[""]});

// ── Anzeige ──
export const num=(x:any):number|null=>x===null||x===undefined||x===""||isNaN(Number(x))?null:Number(x);
export const de=(x:any,d=2)=>{const v=num(x);return v===null?"–":v.toLocaleString("de-DE",{minimumFractionDigits:d,maximumFractionDigits:d});};
export const signed=(x:any,d=1,unit=" %")=>{const v=num(x);if(v===null)return"–";return(v>0?"+":v<0?"−":"")+Math.abs(v).toLocaleString("de-DE",{minimumFractionDigits:d,maximumFractionDigits:d})+unit;};
export const ddmm=(s:any)=>{const m=String(s||"").match(/^(\d{4})-(\d{2})-(\d{2})/);return m?`${m[3]}.${m[2]}.`:"";};
export const labelOf=(list:{value:string;label:string}[],v:string)=>list.find(a=>a.value===v)?.label||v||"–";
export function productLabel(t:any):string{
  if(t.asset_class==="options_warrant")return `OS ${t.call_put==="put"?"Put":t.call_put==="call"?"Call":""}`.trim();
  if(t.asset_class==="knock_out")return `KO ${t.direction==="short"?"Short":t.direction==="long"?"Long":""}`.trim();
  return labelOf(ASSET_CLASSES,t.asset_class);
}
export const strategyOf=(t:any)=>String(t.signal_strategy||t.strategy||"").split(",")[0].trim()||"ohne Strategie";
const STRAT_LABEL=new Map(SIGMUND_STRATEGIES.flatMap(g=>g.items.map(i=>[i.value,i.label] as [string,string])));
export const strategyLabel=(v:string)=>STRAT_LABEL.get(v)||v;
